import { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
  useFormValidation,
} from 'ui'
import {
  FormAliasKeys,
  useAddFormAlias,
} from 'ui/providers/useFormAlias.constate'
import { create } from 'vest'
import { type MoreForLessEffect as MoreForLessEffectType } from '../../../../typings'
import { messages } from './messages'
import { benefitSuite, triggerSuite } from './validation'
import { ViewMoreForLess } from './View'

type MoreForLessProps = {
  name: string
}

export function MoreForLessEffect(props: MoreForLessProps) {
  const { name } = props

  const intl = useIntl()

  const { addAlias } = useAddFormAlias()

  const validation = create((values: MoreForLessEffectType) => {
    triggerSuite(intl, name)(values)
    benefitSuite(intl, name)(values)
  })

  useFormValidation('more-for-less-effect', {
    fieldName: name,
    validateFn: validation,
  })

  useEffect(() => {
    addAlias({
      value: `${name}.benefit.discount.type`,
      key: FormAliasKeys.benefitType,
    })
  }, [addAlias, name])

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          <FormattedMessage {...messages.title} />
        </SectionTitle>
      </SectionHeader>
      <SectionContent space="$space-10" fluid>
        <ViewMoreForLess name={name} />
      </SectionContent>
    </Section>
  )
}
